import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { QueryHandlerResponse } from '../models/responseModels/QueryHandlerResponse';
import { HttpClient } from '@angular/common/http';
import { SCConfig } from '../../sc-config/constant/sc-config.constant';
import { IpexTextCorrection } from '../models/IpexTextCorrection';
import { IpexAiSpellCheck } from '../models/domain/IpexAiSpellCheck';
import { UrlResolverService } from './url/url-resolver.service';

@Injectable({
    providedIn: 'root'
})
export class SpellCheckerService {
    private readonly urlResolver = inject(UrlResolverService);
    private readonly pcxQueryUrl: string = this.urlResolver.getPcxQueryUrl();
    private readonly externalIpexUrl: string = this.urlResolver.getExternalIpexUrl();

    constructor(private httpClient: HttpClient) {}

    public getCorrectedText(payload: any): Observable<QueryHandlerResponse<null, IpexTextCorrection>> {
        let url = this.externalIpexUrl + 'GetCorrectedText';
        return this.httpClient.post<QueryHandlerResponse<null, IpexTextCorrection>>(url, payload, {
            headers: SCConfig.HttpCommonHeader,
            withCredentials: true
        });
    }

    public getSpellCheckerLogs(caseId: string): Observable<QueryHandlerResponse<null, IpexAiSpellCheck[]>> {
        let url = this.externalIpexUrl + 'GetCorrectedText';
        const payload = {
            Content: '',
            QuestionId: '',
            CaseId: caseId,
            ActionType: SCConfig.IpexSpellCheckerActionType.spellLog
        };
        return this.httpClient.post<QueryHandlerResponse<null, IpexAiSpellCheck[]>>(url, payload, {
            headers: SCConfig.HttpCommonHeader,
            withCredentials: true
        });
    }
}
